function kkhybrid_ad_track (opt) {
  hybrid({
    hybridParam: {
      schema: "kkhybrid",
      tagname: "ad_track",
    },
    param: {
      app_id: opt.app_id,
      mini_link: opt.mini_link,
      cp_origin: opt.cp_origin
    },
    callback: function (res) {
      opt.callback && opt.callback(res);
    }
  });
}
function kkmhhybrid_ad_track (opt) {
  hybrid({
    hybridParam: {
      schema: "kkmhhybrid",
      tagname: "ad_track",
    },
    param: {
      app_id: opt.app_id,
      mini_link: opt.mini_link,
      cp_origin: opt.cp_origin
    },
    callback: function (res) {
      opt.callback && opt.callback(res);
    }
  });
}

/**
 * 复制文本<br>
 * kkhybrid://ad_track，wiki地址：{@link https://wiki.quickcan.com/pages/viewpage.action?pageId=6588190}<br>
 * kkmhhybrid://ad_track，wiki地址：{@link https://wiki.quickcan.com/pages/viewpage.action?pageId=301893219}<br>
 * @param {Object} opt 参数对象
 * @param {Number} opt.app_id 游戏ID
 * @param {String} opt.mini_link 跳转短链
 * @param {Number} opt.cp_origin 合作来源（1 TalkingData  2 Reyun  3 AdMaster  4 DoubleClick  5 MiaoZhen）
 * @param {Function} opt.callback 回调函数
 * @param {Number} criticalAppVersion 新旧协议兼容的判断版本（默认值在hybrid/index.js里配置）
 */
function ad_track (opt, criticalAppVersion) {
  var allow = window.kkBaseInfo.allowToKkmhhybrid(criticalAppVersion);
  if(allow) {
    // 调用新协议
    kkmhhybrid_ad_track(opt);
  } else {
    // 调用旧协议
    kkhybrid_ad_track(opt);
  }
}

export default ad_track;


// WEBPACK FOOTER //
// ./node_modules/@kk/h5-sdk/src/ad_track/index.js